import { ref, computed } from 'vue'
import {Inertia} from "@inertiajs/inertia";

// User
const alerts = ref([]);

const useAlerts = {
  get : () => {
    const getAlertsQuery = computed(() => alerts.value )
    return getAlertsQuery.value
  },
  push: (alert) => alerts.value.push(alert),
  delete: (id) => {
    const deletedIndex = alerts.value.indexOf(alerts.value.find(alert=>alert.id==id));
    alerts.value.splice(deletedIndex, 1);
  }
}


export { useAlerts }
